const nextRoutes = [
  {
    path: '/',
    exact: true,
    strict: true,
  },
  {
    path: '/login-loader',
    exact: true,
    strict: true,
  },
  {
    path: '/find/:categoryPath/:searchAreaPath',
    exact: true,
    strict: true,
  },
  {
    path: '/search',
    exact: true,
  },
  {
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20})',
    exact: true,
    strict: true,
  },
  {
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20}-[0-9]{4})',
    exact: true,
    strict: true,
  },
  {
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20})/:pagination',
    exact: true,
    strict: true,
  },
  {
    path:
      '/find/:categoryName/:slug([a-z][-a-z0-9\\._]{1,20}-[qld|nsw|nt|tas|vic|sa|wa|act]{0,20}[a-z][-a-z0-9\\._]{1,20}-[0-9]{4})/:pagination',
    exact: true,
    strict: true,
  },
  {
    path:
      '/find/:categoryName/:state(qld|nsw|nt|tas|vic|sa|wa|act)/:region/:suburb?',
    exact: true,
    strict: true,
  },
  {
    path:
      '/:legacySuburbRoute([a-z][-a-z0-9\\._]{1,20},[qld|nsw|nt|tas|vic|sa|wa|act]{0,20})/:categoryName/:list?',
    exact: true,
  },
  {
    path: '/profile/**',
    exact: true,
    strict: true,
  },
  {
    path: '/search',
    exact: true,
  },
];

export default nextRoutes;
